import React from 'react';
import { BadgeAlt as Badge } from '@cargomatic/ui';
import { titleize, humanize } from 'underscore.string';
import { cn } from 'utils/ui/classes';
function getColor(status) {
    if (!status)
        return 'bg-gray-100 text-gray-800 border-gray-300';
    const key = status.toLowerCase().replace(/\s+/g, '_');
    switch (key) {
        case 'paid':
            return 'bg-green text-white border-green';
        case 'approved_internally':
            return 'bg-green-100 text-green-800 border-green-300';
        case 'sent':
        case 'payment_initialized':
            return 'bg-blue-100 text-blue-800 border-blue-300';
        case 'draft':
        case 'internal_review':
            return 'bg-gray-100 text-gray-800 border-gray-300';
        case 'void':
            return 'bg-red-100 text-red-800 border-red-300';
        case 'credit':
            return 'bg-purple-100 text-purple-800 border-purple-300';
        default:
            return 'bg-gray-100 text-gray-800 border-gray-300';
    }
}
export default function InvoiceStatusBadge({ className = '', status, label, }) {
    if (!status)
        return null;
    return (React.createElement(Badge, { variant: "outline", className: cn('whitespace-nowrap self-start shrink-0 grow-0', getColor(status), className) }, label !== null && label !== void 0 ? label : titleize(humanize(status))));
}
